import { useEffect, useContext } from "react"
import * as Yup from "yup"
import GenericAssetForm from "./common/GenericAssetForm"
import { useFormikContext } from "formik"

// Crypto initial values
export const cryptoInitialValues = {
  cryptoTicker: "",
  walletExchange: "",
  numberOfCoins: "",
  totalOwned: "",
  currentMarketPrice: "",
  networkBlockchain: "",
  walletAddress: "",
  estimatedCurrentValue: "",
}

// Crypto validation schema
export const cryptoValidationSchema = Yup.object().shape({
  name: Yup.string().required("Coin Name is required")
    .min(3, "Min length: 3 characters")
    .max(100, "Max length: 100 characters")
    .matches(
      /^(?! )[A-Za-z0-9\-_.&()]+( [A-Za-z0-9\-_.&()]+)*(?<! )$/,
      "Allowed: letters, numbers, -, _, &, ., (, ). No leading/trailing/blank spaces."
    ),
  purchaseDate: Yup.string().required("Purchase Date is required"),
  purchasePrice: Yup.number()
    .typeError("Must be a positive number")
    .required("Purchase Price is required")
    .positive("Must be a positive number > 0")
    .min(1, "Must be greater than 0"),
  cryptoTicker: Yup.string().required("Coin symbol is required"),
  walletExchange: Yup.string().required("Wallet or Exchange is required"),
  numberOfCoins: Yup.number()
    .typeError("Must be a positive number")
    .required("Number of coins is required")
    .positive("Must be a positive number > 0")
    .min(0.00000001, "Must be greater than 0"),
  totalOwned: Yup.number()
    .typeError("Must be a positive number")
    .required("Total owned is required")
    .positive("Must be a positive number > 0")
    .min(0.00000001, "Must be greater than 0"),
  currentMarketPrice: Yup.number()
    .typeError("Must be a positive number")
    .required("Current market price is required")
    .positive("Must be a positive number > 0")
    .min(0.01, "Must be greater than 0"),
  networkBlockchain: Yup.string().required("Network/Blockchain is required"),
  walletAddress: Yup.string().required("Wallet address is required"),
  estimatedCurrentValue: Yup.number()
    .typeError("Must be a positive number")
    .required("Estimated current value is required")
    .positive("Must be a positive number > 0")
    .min(0.01, "Must be greater than 0"),
})

/**
 * Crypto Form - Field-only component for AddAssets.js
 * This renders only the crypto-specific fields without form wrapper
 * Used in ADD mode within AddAssets.js's existing Formik wrapper
 */
const CryptoForm = ({ values, setFieldValue, errors, touched, defaultCurrency }) => {
  const { setFieldTouched } = useFormikContext() || {}
  
  // Handle default currency setting
  useEffect(() => {
    if ((!values.purchaseCurrency || values.purchaseCurrency === "") && defaultCurrency) {
      setFieldValue("purchaseCurrency", defaultCurrency)
    }
  }, [values.purchaseCurrency, defaultCurrency, setFieldValue])

  return (
    <GenericAssetForm
      subCategory="crypto"
      values={values}
      setFieldValue={setFieldValue}
      setFieldTouched={setFieldTouched}
      errors={errors}
      touched={touched}
      defaultCurrency={defaultCurrency}
      readOnly={false}
    />
  )
}

export default CryptoForm
